import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { Controller } from 'react-hook-form';

import Input from '../../../common/form/Input';
import Select from '../../../common/form/Select';
import RadioButtons from '../../../common/buttons/RadioButtons';
import { InternalFormValues } from './types';
import { shirtSizeOptions, shoeSizeOptions } from './constants';
import { CrewRolesDDOptions } from '../../../../data/models/user';

interface WorkPersonalPreferencesStepProps {
	formValues: InternalFormValues;
	setValue: any;
	control: any;
	errors: any;
	isRequired?: boolean;
}

export default function WorkPersonalPreferencesStep({
	formValues,
	setValue,
	control,
	errors,
	isRequired = true,
}: WorkPersonalPreferencesStepProps) {
	return (
		<Box sx={{ py: 2 }}>
			{/* Work Details */}
			<Typography variant="h6" sx={{ mb: 2, color: 'text.label' }}>
				Work Details
			</Typography>

			<Grid container spacing={3} sx={{ mb: 4 }}>
				<Grid item xs={12}>
					<Controller
						name="role"
						control={control}
						rules={
							isRequired ? { required: 'Role is required' } : {}
						}
						render={({ field }) => (
							<Select
								{...field}
								label="Role"
								options={CrewRolesDDOptions}
								required={isRequired}
								fullWidth
								// error={!!errors.role}
								// helperText={errors.role?.message}
							/>
						)}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Controller
						name="websiteUrl"
						control={control}
						render={({ field }) => (
							<Input
								{...field}
								label="Website / portfolio link"
								fullWidth
								error={!!errors.websiteUrl}
								helperText={errors.websiteUrl?.message}
							/>
						)}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Controller
						name="instagramHandle"
						control={control}
						render={({ field }) => (
							<Input
								{...field}
								label="Instagram handle"
								fullWidth
								error={!!errors.instagramHandle}
								helperText={errors.instagramHandle?.message}
							/>
						)}
					/>
				</Grid>
				<Grid item xs={12}>
					<Controller
						name="healthInsurance"
						control={control}
						render={({ field }) => (
							<RadioButtons
								label="Are you planning to opt in to Blue Ox provided health insurance"
								name="healthInsurance"
								options={[
									{
										value: 'yes',
										label: 'Yes, opting in to BX health insurance',
									},
									{
										value: 'no',
										label: 'No, I do not want BX health insurance',
									},
								]}
								value={field.value}
								onChange={field.onChange}
								row={false}
							/>
						)}
					/>
				</Grid>
				<Grid item xs={12}>
					<Controller
						name="professionalLicenses"
						control={control}
						render={({ field }) => (
							<Input
								{...field}
								label="Other professional licenses (ex. CPR)"
								fullWidth
								multiline
								rows={4}
								error={!!errors.professionalLicenses}
								helperText={
									errors.professionalLicenses?.message
								}
							/>
						)}
					/>
				</Grid>
			</Grid>

			{/* Personal Preferences */}
			<Typography variant="h6" sx={{ mb: 2, color: 'text.label' }}>
				Personal Preferences
			</Typography>

			<Grid container spacing={3} sx={{ mb: 4 }}>
				<Grid item xs={12}>
					<Controller
						name="dietaryRestrictions"
						control={control}
						render={({ field }) => (
							<Input
								{...field}
								label="Dietary restrictions"
								fullWidth
								multiline
								rows={4}
								error={!!errors.dietaryRestrictions}
								helperText={errors.dietaryRestrictions?.message}
							/>
						)}
					/>
				</Grid>
				<Grid item xs={12}>
					<Controller
						name="photographyConsent"
						control={control}
						render={({ field }) => (
							<RadioButtons
								label="Are you willing to be photographed on set for behind the scenes capture?"
								name="photographyConsent"
								options={[
									{ value: 'yes', label: 'Yes' },
									{ value: 'no', label: 'No' },
								]}
								value={field.value}
								onChange={field.onChange}
								row
							/>
						)}
					/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<Controller
						name="shirtSize"
						control={control}
						render={({ field }) => (
							<Select
								{...field}
								label="Shirt size"
								options={shirtSizeOptions}
								fullWidth
							/>
						)}
					/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<Controller
						name="pantSize"
						control={control}
						render={({ field }) => (
							<Select
								{...field}
								label="Pant size"
								options={shirtSizeOptions}
								fullWidth
							/>
						)}
					/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<Controller
						name="shoeSize"
						control={control}
						render={({ field }) => (
							<Select
								{...field}
								label="Shoe size"
								options={shoeSizeOptions}
								fullWidth
							/>
						)}
					/>
				</Grid>
				<Grid item xs={12}>
					<Controller
						name="biopoc"
						control={control}
						render={({ field }) => (
							<RadioButtons
								label="BIOPOC"
								name="biopoc"
								options={[
									{ value: 'yes', label: 'Yes' },
									{ value: 'no', label: 'No' },
								]}
								value={field.value}
								onChange={field.onChange}
								row
							/>
						)}
					/>
				</Grid>
			</Grid>
		</Box>
	);
}
